<template>
  <div>
    <p class="title text-left">四川小贷行业考察团莅临及时雨小贷公司参观交流</p>
    <p class="desc text-left">2018-10-25　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">2018年10月25四川小贷行业考察团莅临及时雨小贷公司参观交流。</p>
      <p class="normal">会议参加的单位有：上海小贷行业协会，四川省小贷行业协会以及十余家四川省的小贷公司代表。及时雨小贷CEO尹君就及时雨小贷经营情况与大家进行现场交流分享。</p>
      <div class="normal"><img src="../img/newsDetail/4-01.png" width="100%" alt=""></div>
      <p class="normal">上海嘉定及时雨小额贷款股份有限公司是经上海市政府批准设立的专业融资机构，注册资本金2亿元。公司自开业以来，一直坚持“小额、分散”的经营原则，严格按照现代企业制度进行管理，构建了运行规范、权责清晰的公司管理体系。</p>
      <p class="normal">凭借专业的管理团队、先进的经营理念、丰富的行业经验、成熟的运作模式和创新的产品服务，专注于微型金融业务市场，努力为本市的小企业，个体工商户提供专业、全面的小额信贷服务。</p>
      <p class="normal">在交流中，大家对及时雨小贷“线上线下相结合”的风控理念表示了认同；对及时雨小贷高效的风控系统与信息系统，印象深刻；对及时雨小贷年轻、高素质的管理团队，表示赞许与鼓励。</p>
      <div class="normal"><img src="../img/newsDetail/4-02.png" width="100%" alt=""></div>
      <p class="normal">会后，大家合影留念，四川小贷行业考察团鼓励及时雨小贷：坚持以诚信为本，充分利用科技手段提高工作效率的同时，一时一刻也不能放松对金融风险的有效防控。</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail4"
  }
</script>

<style scoped lang="less">
  @import "newsDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail4.vue